// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBcV5KOTMsuceESgi6OngsxIZ4OOgTxJTo",
    authDomain: "firechat-b6756.firebaseapp.com",
    databaseURL: "https://firechat-b6756.firebaseio.com",
    projectId: "firechat-b6756",
    storageBucket: "firechat-b6756.appspot.com",
    messagingSenderId: "957976676143"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
